import { useLayoutEffect, useState } from 'preact/hooks';
import { cardsPerRow, coversPerRow } from './model';

/**
 * How many covers fit in a row of this shelf (measured; it changes with the window). A callback
 * ref, so a shelf folded and opened again is measured on its new element (Kristi, Oct 28: the
 * old element, gone, measured 0 wide and the shelf showed one cover a row).
 */
export function usePerRow(narrow: boolean) {
  const [el, setEl] = useState<HTMLDivElement | null>(null);
  const [perRow, setPerRow] = useState(6);
  const [cardRow, setCardRow] = useState(narrow ? 1 : 3);
  useLayoutEffect(() => {
    if (!el) return;
    const measure = () => {
      if (!el.isConnected || el.clientWidth < 60) return; // folded, or not laid out yet
      setPerRow(coversPerRow(el.clientWidth - 32, narrow));
      setCardRow(cardsPerRow(el.clientWidth, narrow));
    };
    measure();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    ro?.observe(el);
    return () => ro?.disconnect();
  }, [el, narrow]);
  return { ref: setEl, perRow, cardRow };
}

